<template>
    <!-- filterable list of signals with link to data -->
  <b-modal id="modal-2" title="Signal Nodes" size="lg">
    <div>
      <b-row>
        <b-col>
          Filter by Geography:
        </b-col>
        <b-col class="">
          <b-form-group label-for="iso_filter" description="ISO starts with" >
            <b-form-input id="iso_filter"  v-model="filterISO" @input="filterAndSort()"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-for="name_filter" description="Signal name contains" >
            <b-form-input id="name_filter" v-model="filterName" @input="filterAndSort()"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="mt-2 mb-2">
      <b-row>
        <b-col>ISO</b-col>
        <b-col>Signal Name</b-col>
        <b-col></b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div class="scrollable-300 mt-2 mb-2">
      <b-row v-for="s in filteredSignals" :key="s.name" class="parent">
          <b-col sm="3">{{s.iso_name}}</b-col>
          <b-col>{{s.name}}</b-col>
          <b-col sm="1"><b-link @click="view(s.name)">view</b-link></b-col>
          <b-col sm="2"><b-link :href="baseUrl + s.name" target="0">raw data</b-link></b-col>
      </b-row>
    </div>
    Shown: {{filteredSignals.length.toLocaleString()}},&nbsp;
    Matched: {{filterMatched.toLocaleString()}},&nbsp;
    Total Nodes: {{allSignals.length.toLocaleString()}}
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="primary" @click="cancel()">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { EventBus } from '@/eventBus'
import axios from 'axios'

const limit = 1500 // too slow and unwieldy, let them narrow the criteria

export default {

  props: ['baseUrl'],
  data () {
    return {
      error: null,
      allSignals: [],
      filteredSignals: [],
      filterMatched: 0,
      filterISO: '',
      filterName: '',
      filterText: 'Enter provider (optional) and name, example "c 12" or "12"'
    }
  },
  created () {
    console.log('fetching list of all signals...')
    this.error = null
    var self = this
    axios.get(this.baseUrl).then(function (response) {
      if (response.data.signal === null) {
        console.log('error - no data')
        self.error = 'error - no data'
      } else {
        console.log(response.data.length + ' signal(s) received')
        self.allSignals = response.data
        self.filterAndSort()
      }
    }, function (err) {
      self.error = 'Not happening'
      console.log('nope ' + err)
    })
  },
  methods: {
    sortFunction (a, b) {
      let x = a.iso_name.localeCompare(b.iso_name)
      if (x === 0) {
        x = a.name.localeCompare(b.name)
      }
      return x
    },
    filterAndSort () {
      console.log('applying filter, iso starts with: ' + this.filterISO + ', name contains: ' + this.filterName)
      this.filteredSignals = [...this.allSignals]
      if (this.filterISO.trim().length > 0) {
        this.filteredSignals = this.filteredSignals.filter(e => {
          return e.iso_name.toLowerCase().startsWith(this.filterISO.toLowerCase())
        })
      }
      if (this.filterName.trim().length > 0) {
        this.filteredSignals = this.filteredSignals.filter(e => {
          return e.name.toLowerCase().indexOf(this.filterName.toLowerCase()) >= 0
        })
      }
      this.filteredSignals = this.filteredSignals.sort(this.sortFunction)
      console.log('filtered and sorted, ' + this.filteredSignals.length + ' item(s)')
      this.filterMatched = this.filteredSignals.length
      if (this.filteredSignals.length > limit) {
        this.filteredSignals.length = limit
      }
    },
    view (node) {
      console.log('viewing node: ' + node)
      EventBus.$emit('signal-selected', node)
      this.$bvModal.hide('modal-2')
    }
  }
}
</script>
